import api from "@/api/api";

export const getFolders = async (parentId = null, isArchived = null) => {
  const res = await api.get(`/folders`, { params: { parentId, isArchived } });
  return res.data || [];
};

export const getFoldersByEntity = async (entityId, folderId, params) => {
  const url = folderId
    ? `/folders/${entityId}/${folderId}`
    : `/folders/${entityId}`;
  const res = await api.get(url, params ? { params } : undefined);
  return res.data || {};
};

export const getFolder = async (id, config = {}) => {
  const res = await api.get(`/folders/${id}`, config);
  return res.data;
};

export const addFolder = (folder) => {
  return api.post(`/folders`, folder);
};

export const updateFolder = (folderId, folder) => {
  return api.patch(`/folders/${folderId}`, folder);
};

export const updateFolderGradingDetails = (
  folderId,
  gradingDetails,
  config = {}
) => {
  return api.patch(
    `/folders/${folderId}/grading-details`,
    gradingDetails,
    config
  );
};

export const getFolderLmsSubmissions = (folderId) => {
  return api.get(`/folders/${folderId}/lms-submissions`);
};

export const setFolderLmsSubmissions = (folderId, submissionsIds) => {
  return api.put(`/folders/${folderId}/lms-submissions`, { submissionsIds });
};

export const deleteFolder = (folderId) => {
  return api.delete(`/folders/${folderId}`);
};

// Duplicate folder on server
export const duplicateFolder = (folderId) => {
  return api.put(`/folders/${folderId}/duplicate`);
};
